import { SafeEventEmitterProvider } from '@web3auth/base'
import ethProvider from './ethProvider'

// Defining funtions for Eth Provider
export interface IWalletProvider {
  getAccounts: () => Promise<any>
  getMaticBalance: () => Promise<any>
  sendMaticTokens: (to: string, value: number) => Promise<any>
  signTransaction: () => Promise<void>
  getTransactions: (page: number, offset: number) => Promise<any>
  getNFTTokens: () => Promise<any>
  sendMaltTokens: (to: string, value: number) => Promise<any>
  getMaltBalance: () => Promise<any>
  signMessage: (emoji: string) => any
  metaMaskSign: () => any
  sendAsset: (address: string, tokenid: any) => Promise<void>
  getMarketplaceFee: () => Promise<void>
  mintAlterBody: (
    isBiconomyInitialized: any,
    biconomyProvider: any,
    contractAlter: any,
    tokenuri: string,
    data: any,
    assetId: any
  ) => Promise<any>
  mint3DBody: (
    isBiconomyInitialized: any,
    biconomyProvider: any,
    contractAlter: any,
    tokenuri: string,
    data: any,
    assetId: any
  ) => Promise<any>
  listForSale: (
    isErc721: any,
    nftAddress: any,
    tokenIds: any,
    price: any,
    seller: any,
    amount: any,
    erc20Address: any,
    assetId: any,
    currentCategory: string
  ) => Promise<any>
  getGasFee: () => Promise<any>
  buyNFT: (
    listingId: any,
    erc20Address: any,
    assetId: any,
    price: any
  ) => Promise<any>
  updateNFTListing: (listingId: any, assetId: any, price: any) => Promise<void>
  getListingId: (assetId: string) => Promise<any>
  cancelNFTListing: (listingId: any, assetId: any) => Promise<void>
  ApproveCheck: (currentCategory: any) => Promise<void>
  ApproveNFT: (currentCategory: any) => Promise<void>
  getOpenListing: () => Promise<void>
  getNoOfFreeMints: () => Promise<void>
  getPrivateKey: () => Promise<void>
}

export const getWalletProvider = (
  chain: string,
  provider: SafeEventEmitterProvider
): IWalletProvider => ethProvider(provider)
